export default __webpack_public_path__ + "6d6a6dc1d29c5d2451c6b7fa0e01359f.png";